module.exports = "/circle-cross.aceefd0c8da286480138b415c0f1f71dceff2f79.svg";